import * as React from 'react';
import {Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {Site} from '../api/dtos/dtos';
import locales from '../locales';
import InputFormItem from '../common/form-items/InputFormItem';
import SubmitCancelFormItem from '../common/form-items/SubmitCancelFormItem';
import {addressSuffix} from '../utils/form-utils';


interface ClientSiteFormProps extends FormComponentProps {
  site: Site;
  onFormSubmit: (site: Site) => void;
  onFormCancel: () => void;
}

const FIELD_ADDRESS = 'address';
const FIELD_NAME = 'name';

class ClientSiteForm extends React.Component<ClientSiteFormProps, {}> {

  public render() {
    const {form, site} = this.props;
    return (
      <Form>
        <InputFormItem
          form={form}
          fieldId={FIELD_ADDRESS}
          label={locales.address}
          initialValue={site.address}
          required={true}
          addonAfter={site.address && addressSuffix(site.address)}
        />

        <InputFormItem
          form={form}
          fieldId={FIELD_NAME}
          label={locales.appellation}
          initialValue={site.name}
          required={false}
        />

        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {site, form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit({
          ...site,
          address: values[FIELD_ADDRESS],
          name: values[FIELD_NAME],
        });
      }
    });
  };
}

export default Form.create<ClientSiteFormProps>()(ClientSiteForm);



// WEBPACK FOOTER //
// ./src/client-details/ClientSiteForm.tsx